import React from 'react';

const AboutUsHeroVector = ({ ...props }) => (
  <svg
    width="419"
    height="415"
    viewBox="0 0 419 415"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M411.271 415H7.72945C5.67947 415 3.71345 414.187 2.2639 412.739C0.814345 411.291 0 409.327 0 407.28V208.953C6.92207e-07 207.938 0.200323 206.934 0.589474 205.996C0.978626 205.059 1.54899 204.207 2.26794 203.49L204.038 2.25717C205.488 0.811811 207.452 0 209.5 0C211.548 0 213.512 0.811811 214.962 2.25717L416.732 203.49C417.451 204.207 418.021 205.059 418.411 205.996C418.8 206.934 419 207.938 419 208.953V407.28C419 409.327 418.186 411.291 416.736 412.739C415.287 414.187 413.321 415 411.271 415Z"
      fill="#381C08"
    />
  </svg>
);

export default AboutUsHeroVector;
